import { digest, log } from "./utils";
import Api from "./singleton/api";
import flBusiness from "./index";
import Global from "./global";

export default function adminInit(): void {

    Object.assign(window, {
        admin: async function(password: string): Promise<void> {
            const hash: string = await digest(password);
            if (hash === Global.ADMIN_PASS_HASH) {
                log('Welcome home :)', 'green');
                Object.assign(window, {
                    FLapp: Api.app,
                    FLapi: Api.api,
                    FLusr: Api.usr,
                    flBusiness
                });
            } else {
                log('Oops...', 'red');
            }
        }
    });

}
